module.exports = __webpack_public_path__ + "media/components/app-store/static/sfc-featured-b22f30cac952f38d889115a64461b896.jpg";